/* Loaded by native cart-products (drawer on all storefront pages) and recent section.
   Runtime product reads only; never changes product/collection assignments or catalogue. */
const HISTORY_KEY = 'mr-recent-product-handles';
let handles = [];
try {
  handles = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
  if (!Array.isArray(handles)) handles = [];
  const old = JSON.parse(localStorage.getItem('theme-recent') || '{}');
  handles = [...new Set([...handles, ...Object.keys(old).reverse()])];
  const productPath = location.pathname.match(/\/products\/([^/?#]+)/);
  if (productPath) handles = [decodeURIComponent(productPath[1]), ...handles.filter((h) => h !== decodeURIComponent(productPath[1]))];
  handles = handles.filter((h) => typeof h === 'string' && h.length < 255).slice(0, 20);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(handles));
} catch { handles = []; }
async function renderRecent(section) {
  if (section.dataset.mrInitialized) return;
  section.dataset.mrInitialized = 'true';
  const grid = section.querySelector('[data-mr-recent-grid]');
  const count = Math.max(2, Math.min(10, Number(section.dataset.count) || 5));
  const currency = section.dataset.currency || 'USD';
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
  const root = (section.dataset.root || '/').replace(/\/?$/, '/');
  const current = location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  const selected = handles.filter((h) => h !== current).slice(0, count);
  const results = await Promise.all(selected.map(async (handle) => {
    try { const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' }); return response.ok ? await response.json() : null; } catch { return null; }
  }));
  if (!grid?.isConnected) return;
  grid.replaceChildren();
  results.filter(Boolean).forEach((product) => {
    const variant = product.variants?.find((v) => v.available) || product.variants?.[0];
    const card = document.createElement('a'); card.href = `${root}products/${encodeURIComponent(product.handle)}`;
    if (product.featured_image) { const image = document.createElement('img'); image.src = product.featured_image; image.alt = product.title; image.loading = 'lazy'; image.width = 360; image.height = 360; card.append(image); }
    const title = document.createElement('h4'); title.textContent = product.title; card.append(title);
    const price = document.createElement('div'); price.className = 'mr-aux-recent-price'; const cents = variant?.price ?? product.price; price.textContent = formatter.format(cents / 100);
    const compare = variant?.compare_at_price;
    if (compare > cents) { const old = document.createElement('s'); old.textContent = formatter.format(compare / 100); price.append(old); }
    card.append(price); grid.append(card);
  });
  section.hidden = !grid.childElementCount;
}
function initRecent(scope = document) { scope.querySelectorAll('[data-mr-recently-viewed]').forEach(renderRecent); }
initRecent();
document.addEventListener('shopify:section:load', (event) => initRecent(event.target));
